import { useSelector } from "react-redux";
import { StateExtended } from "../../_config/interfaces/stateExtended";

export const useEmployeeTypesSelector = () => useSelector((state: StateExtended) => state.userManagement.employeeTypes);
